export const BusinessImageType = {
  Logo: "Logo",
  Cover: "Cover",
  Gallery: "Gallery",
};
